import lang from './en';

export default lang;
